export default __webpack_public_path__ + "static/media/h.8ce1ab3b.png";